<template>
  <div>
    <div v-if="type == 'single'">
      <div v-if="cost != 0" @click="costShow()" :id="'cost' + index">
        <span class="router-link" style="font-size: 10px">¥{{ cost | addComma }}</span>
      </div>
      <div v-else @click="costShow()" :id="'cost' + index" class="router-link">
        コスト設定
      </div>
      <transition name="fade">
        <div class="data-table-cost-popup" v-if="cost_show" :class="cost_position == 'top' ? 'top' : 'bottom'">
          <el-radio v-model="cost_type" label="free" class="cost-check">コスト(自由設定)</el-radio>
          <div class="data-table-cost-input-wrap top" :class="cost_type != 'free' ? 'disabled' : ''" @click="cost_type = 'free'">
            <span style="margin-right: 10px">¥</span>
            <input type="number" class="data-table-cost-input" v-model="cost_value" style="width: 100%" :disabled="cost_type != 'free'" min="0" step="1000" @keydown.enter="addCost()" />
          </div>
          <el-radio v-model="cost_type" label="unit" class="cost-check">コスト(フォロワー単価で設定)</el-radio>
          <div class="data-table-cost-input-unit">
            <div class="data-table-cost-input-wrap medium" :class="cost_type != 'unit' ? 'disabled' : ''" @click="cost_type = 'unit'">
              <span style="margin-right: 10px">¥</span>
              <input type="number" class="data-table-cost-input medium" min="0" step="0.1" v-model="cost_per_unit" :disabled="cost_type != 'unit'" @keydown.enter="addCost()" />
            </div>
            <span style="color: #aaa; margin-left: 10px"> ×{{ followers_count | addComma }} </span>
          </div>
          <div class="data-table-cost-popup-button">
            <div class="pointer" style="font-size: 10px" @click="cost_show = false">
              キャンセル
            </div>
            <el-button size="small" type="primary" style="width: 65%" @click="report_id == 'demo' ? '' : addCost()" :disabled="cost_loading || report_id == 'demo'">
              <div class="flex-row">
                コストを設定
                <div class="loader--mini" v-show="cost_loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </transition>
    </div>

    <div v-if="type == 'bundle' || type == 'media_bundle'">
      <div @click="report_id == 'demo' ? '' : costShow()" :id="'cost10000'" style="margin-right:20px; font-weight:700" class="router-link" :style="report_id == 'demo' ? 'opacity: 0.5' : ''">
        <font-awesome-icon :icon="['far', 'yen-sign']" />
        コスト設定
      </div>
      <transition name="fade">
        <div class="data-table-cost-popup bundle" v-if="cost_show" :class="cost_position == 'top' ? 'top' : 'bottom'">
          <el-radio v-model="cost_type" label="free" class="cost-check">コスト(自由設定)</el-radio>
          <div class="data-table-cost-input-wrap top" :class="cost_type != 'free' ? 'disabled' : ''" @click="cost_type = 'free'">
            <span style="margin-right: 10px">¥</span>
            <input type="number" class="data-table-cost-input" min="0" step="1000" v-model="cost_value" style="width: 100%" :disabled="cost_type != 'free'" @keydown.enter="type=='bundle' ? addCost() : addCostMedia()" />
          </div>
          <el-radio v-model="cost_type" label="unit" class="cost-check">コスト(フォロワー単価で設定)</el-radio>
          <div class="data-table-cost-input-unit">
            <div class="data-table-cost-input-wrap medium" :class="cost_type != 'unit' ? 'disabled' : ''" @click="cost_type = 'unit'">
              <span style="margin-right: 10px">¥</span>
              <input type="number" class="data-table-cost-input medium" min="0" step="0.1" v-model="cost_per_unit" :disabled="cost_type != 'unit'" @keydown.enter="type=='bundle' ? addCost() : addCostMedia()" />
            </div>
          </div>
          <div class="data-table-cost-popup-button">
            <div class="pointer" style="font-size: 10px" @click="cost_show = false">
              キャンセル
            </div>
            <el-button size="small" type="primary" style="width: 65%" @click="type=='bundle' ? addCost() : addCostMedia()" :disabled="cost_loading">
              <div class="flex-row">
                コストを設定
                <div class="loader--mini" v-show="cost_loading"></div>
              </div>
            </el-button>
          </div>
        </div>
      </transition>
    </div>

    <!-- cost modal bg -->
    <div class="cost-overlay" v-show="cost_show" @click="cost_show = false"></div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const addCostAPI = root + "/api/report/add_cost";
const changeReportPostAPI = root + "/api/report/change_report_post";

export default {
  name: "costSetting",
  props: ["id", "cost", "followers_count", "index", "checkList", "report_id", "sns_type", "type"],
  data() {
    return {
      cost_show: false,
      cost_value: 0,
      cost_per_unit: 1,
      cost_type: "unit",
      cost_loading: false,
      cost_position: "",
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    var cost_before = Number(this.cost);
    this.cost_value = cost_before;
  },
  methods: {
    addCost() {
      this.cost_loading = true;
      if (this.type == "single") {
        var influencer = [];
        influencer.push(this.id);
      } else if (this.type == "bundle") {
        influencer = this.checkList;
      } 
      var params = new URLSearchParams();
      params.append("report_id", this.report_id);
      params.append("sns_type", this.sns_type);
      params.append("cost_type", this.cost_type);
      params.append("cost_value", this.cost_value);
      params.append("cost_per_unit", this.cost_per_unit);
      params.append("influencer", JSON.stringify(influencer));
      params.append("token", this.token);
      this.axios
        .post(addCostAPI, params)
        .then((response) => {
          this.cost_loading = false;
          this.cost_show = false;
          if (this.type == "single") {
            this.$emit("syncCost", this.index, response.data.sync, response.data.total, "single");
          } else if (this.type == "bundle") {
            this.$emit("syncCost", "", response.data.sync, response.data.total, "bundle");
          }
          this.$emit("loadReportDetail");
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "コストを設定しました",
          });
        })
        .catch(() => {
          this.cost_loading = false;
          this.cost_show = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "コストの設定に失敗しました",
          });
        });
    },
    addCostMedia(){
      this.cost_loading = true;
      var params = new URLSearchParams();
      params.append("cost_type", this.cost_type);
      params.append("report_id", this.report_id);
      params.append("column", "cost");
      params.append("value", this.cost_type == 'free' ? this.cost_value : this.cost_per_unit);
      params.append("media_list", JSON.stringify(this.checkList));
      params.append("token", this.token);
      this.axios
        .post(changeReportPostAPI, params)
        .then(() => {
          this.cost_loading = false;
          this.cost_show = false;
          this.$emit("reload");
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "コストを設定しました",
          });
        })
        .catch(() => {
          this.cost_loading = false;
          this.cost_show = false;
          this.$message({
            type: "error",
            offset: 7,
            showClose: true,
            message: "コストの設定に失敗しました",
          });
        });
    },
    costShow() {
      var costTop = document.getElementById("cost" + this.index).getBoundingClientRect().top;
      var windowHeight = document.documentElement.clientHeight;
      if (windowHeight - costTop < 280) {
        this.cost_position = "top";
      } else {
        this.cost_position = "bottom";
      }
      this.cost_show = true;
    },
  },
  filters: {
    addComma(val) {
      return Math.floor(val).toLocaleString();
    },
  },
};
</script>

<style></style>
